export class PageForbiddenError extends Error {
  public static readonly code = 403;
}
